import {useRouter} from "next/router";
import {useMemo} from "react";

export default function useIsWWDSingleAction() {
	const router = useRouter()
	return useMemo(() => {
		return Object.keys(router.query).includes('action')
	}, [router])
}
